export class ChunkAPI {
  constructor(req) {
    this.req = req;
  }

  async getChunk(app_id, chunk_id) {
    return this.req.axiosRequest({
      url: `${this.req.root}/api/get-items-chunk/${app_id}/${chunk_id}`,
      method: 'GET'
    });
  }

  async getLastChunk(app_id) {
    return this.req.axiosRequest({
        url: `${this.req.root}/api/get-last-items-chunk/${app_id}`,
        method: 'GET'
    });
  }
};
